// https://firebase.google.com/docs/database/web/read-and-write
import all from './all';
import commit from './commit';
import read from './read';
import remove from './remove';

export default {
  all,
  commit,
  read,
  remove,
};
